function random_range(h, n) {
  return Math.floor(Math.random() * (h - n)) + n
}

export function replace_marketing_product_selector(self, response) {
  if (!response || !self.is_buff) return

  if (self.username === 'umiha') {
    const up = 80

    // console.log('replace_marketing_product_selector', response)
    if (response.data && response.data.data && response.data.data.item_list) {
      for (const item of response.data.data.item_list) {
        // item.name = item.name.replace(/umiha/ig, '').trim()
        // item.name = item.name.replace(/umihome/ig, '').trim()
        item.name = 'Sản phẩm ' + random_range(1000, 9999)

        const images_length = item.images.split(',').length
        const replace_index = Math.floor(images_length / 2)
        item.images = item.images.split(',')[replace_index] ? item.images.split(',')[replace_index] + ',' + item.images : item.images.split(',')[images_length - 1] + ',' + item.images

        // item.images = item.images.split(',').reverse().join(';  ')

        item.sold += Math.floor(item.sold * up / 100)
        item.monthly_sales += Math.floor(item.monthly_sales * up / 100)
      }
    }
  }

  if (self.username === 'shopbosoup') {
    const up = 50

    // console.log('replace_marketing_product_selector', response)
    if (response.data && response.data.data && response.data.data.item_list) {
      for (const item of response.data.data.item_list) {
        // item.name = item.name.replace(/shop bố soup/ig, '').trim()
        // item.name = item.name.replace(/shop bo soup/ig, '').trim()
        // item.name = item.name.replace(/bố soup/ig, '').trim()
        // item.name = item.name.replace(/bo soup/ig, '').trim()
        item.name = 'Sản phẩm ' + random_range(1000, 9999)

        const images_length = item.images.split(',').length
        const replace_index = Math.floor(images_length / 2)
        item.images = item.images.split(',')[replace_index] ? item.images.split(',')[replace_index] + ',' + item.images : item.images.split(',')[images_length - 1] + ',' + item.images

        // item.images = item.images.split(',').reverse().join(';  ')

        item.sold += Math.floor(item.sold * up / 100)
        item.monthly_sales += Math.floor(item.monthly_sales * up / 100)
      }
    }
  }
}

export function replace_marketing_pas_get_campaigns(self, response) {
  if (!response || !self.is_buff) return

  if (self.username === 'umiha') {
    const up = 80

    // console.log('replace_marketing_pas_get_campaigns', response)
    if (response.data && response.data.data && response.data.data.entry_list) {
      for (const item of response.data.data.entry_list) {
        // item.title = item.title.replace(/umiha/ig, '').trim()
        // item.title = item.title.replace(/umihome/ig, '').trim()
        item.title = 'Quảng cáo sản phẩm ' + random_range(1000, 9999)
        if (item.type === 'shop_manual') item.title = 'Quảng cáo shop ' + random_range(1000, 9999)

        item.report.impression += Math.floor(item.report.impression * up / 100)
        item.report.click += Math.floor(item.report.click * up / 100)
        item.report.broad_order += Math.floor(item.report.broad_order * up / 100)
        item.report.broad_gmv += Math.floor(item.report.broad_gmv * up / 100)
        item.report.direct_gmv += Math.floor(item.report.direct_gmv * up / 100)
        // item.report.cost += Math.floor(item.report.cost * up / 100)
      }
    }
  }

  if (self.username === 'shopbosoup') {
    const up = 50

    // console.log('replace_marketing_pas_get_campaigns', response)
    if (response.data && response.data.data && response.data.data.entry_list) {
      for (const item of response.data.data.entry_list) {
        // item.title = item.title.replace(/shop bố suop/ig, '').trim()
        // item.title = item.title.replace(/shop bo suop/ig, '').trim()
        // item.title = item.title.replace(/bố soup/ig, '').trim()
        // item.title = item.title.replace(/bo soup/ig, '').trim()
        item.title = 'Quảng cáo sản phẩm ' + random_range(1000, 9999)
        if (item.type === 'shop_manual') item.title = 'Quảng cáo shop ' + random_range(1000, 9999)

        item.report.impression += Math.floor(item.report.impression * up / 100)
        item.report.click += Math.floor(item.report.click * up / 100)
        item.report.broad_order += Math.floor(item.report.broad_order * up / 100)
        item.report.broad_gmv += Math.floor(item.report.broad_gmv * up / 100)
        item.report.direct_gmv += Math.floor(item.report.direct_gmv * up / 100)
        // item.report.cost += Math.floor(item.report.cost * up / 100)
      }
    }
  }
}

export function replace_marketing_get_time_graph(self, response) {
  if (!response || !self.is_buff) return

  if (self.username === 'umiha') {
    const up = 80

    // console.log('replace_marketing_get_time_graph', response)
    if (response.data && response.data.data && response.data.data.report_aggregate) {
      response.data.data.report_aggregate.impression += Math.floor(response.data.data.report_aggregate.impression * up / 100)
      response.data.data.report_aggregate.click += Math.floor(response.data.data.report_aggregate.click * up / 100)
      response.data.data.report_aggregate.broad_order += Math.floor(response.data.data.report_aggregate.broad_order * up / 100)
      response.data.data.report_aggregate.broad_gmv += Math.floor(response.data.data.report_aggregate.broad_gmv * up / 100)
      response.data.data.report_aggregate.direct_gmv += Math.floor(response.data.data.report_aggregate.direct_gmv * up / 100)
      // response.data.data.report_aggregate.cost += Math.floor(response.data.data.report_aggregate.cost * up / 100)
    }

    if (response.data && response.data.data && response.data.data.report_aggregate) {
      for (const item of response.data.data.report_by_time) {
        item.metrics.impression += Math.floor(item.metrics.impression * up / 100)
        item.metrics.click += Math.floor(item.metrics.click * up / 100)
        item.metrics.broad_order += Math.floor(item.metrics.broad_order * up / 100)
        item.metrics.broad_gmv += Math.floor(item.metrics.broad_gmv * up / 100)
        item.metrics.direct_gmv += Math.floor(item.metrics.direct_gmv * up / 100)
        // item.metrics.cost += Math.floor(item.metrics.cost * up / 100)
      }
    }
  }

  if (self.username === 'shopbosoup') {
    const up = 50

    // console.log('replace_marketing_get_time_graph', response)
    if (response.data && response.data.data && response.data.data.report_aggregate) {
      response.data.data.report_aggregate.impression += Math.floor(response.data.data.report_aggregate.impression * up / 100)
      response.data.data.report_aggregate.click += Math.floor(response.data.data.report_aggregate.click * up / 100)
      response.data.data.report_aggregate.broad_order += Math.floor(response.data.data.report_aggregate.broad_order * up / 100)
      response.data.data.report_aggregate.broad_gmv += Math.floor(response.data.data.report_aggregate.broad_gmv * up / 100)
      response.data.data.report_aggregate.direct_gmv += Math.floor(response.data.data.report_aggregate.direct_gmv * up / 100)
      // response.data.data.report_aggregate.cost += Math.floor(response.data.data.report_aggregate.cost * up / 100)
    }

    if (response.data && response.data.data && response.data.data.report_aggregate) {
      for (const item of response.data.data.report_by_time) {
        item.metrics.impression += Math.floor(item.metrics.impression * up / 100)
        item.metrics.click += Math.floor(item.metrics.click * up / 100)
        item.metrics.broad_order += Math.floor(item.metrics.broad_order * up / 100)
        item.metrics.broad_gmv += Math.floor(item.metrics.broad_gmv * up / 100)
        item.metrics.direct_gmv += Math.floor(item.metrics.direct_gmv * up / 100)
        // item.metrics.cost += Math.floor(item.metrics.cost * up / 100)
      }
    }
  }
}

export function replace_marketing_get_report(self, response) {
  if (!response || !self.is_buff) return

  if (self.username === 'umiha') {
    const up = 80

    // console.log('replace_marketing_get_report', response)
    if (response.data && response.data.data) {
      for (const item of response.data.data) {
        item.metrics.impression += Math.floor(item.metrics.impression * up / 100)
        item.metrics.click += Math.floor(item.metrics.click * up / 100)
        item.metrics.broad_order += Math.floor(item.metrics.broad_order * up / 100)
        item.metrics.broad_gmv += Math.floor(item.metrics.broad_gmv * up / 100)
        item.metrics.direct_gmv += Math.floor(item.metrics.direct_gmv * up / 100)
        // item.metrics.cost += Math.floor(item.metrics.cost * up / 100)
      }
    }
  }

  if (self.username === 'shopbosoup') {
    const up = 50

    // console.log('replace_marketing_get_report', response)
    if (response.data && response.data.data) {
      for (const item of response.data.data) {
        item.metrics.impression += Math.floor(item.metrics.impression * up / 100)
        item.metrics.click += Math.floor(item.metrics.click * up / 100)
        item.metrics.broad_order += Math.floor(item.metrics.broad_order * up / 100)
        item.metrics.broad_gmv += Math.floor(item.metrics.broad_gmv * up / 100)
        item.metrics.direct_gmv += Math.floor(item.metrics.direct_gmv * up / 100)
        // item.metrics.cost += Math.floor(item.metrics.cost * up / 100)
      }
    }
  }
}

export function replace_get_product_by_page(self, response) {
  if (!response || !self.is_buff) return

  if (self.username === 'umiha') {
    const up = 80

    // console.log('replace_get_product_by_page', response)
    if (response.data && response.data.data && response.data.data.products) {
      for (const item of response.data.data.products) {
        // item.name = item.name.replace(/umiha/ig, '').trim()
        // item.name = item.name.replace(/umihome/ig, '').trim()
        item.name = 'Sản phẩm ' + random_range(1000, 9999)

        const images_length = item.images.length
        const replace_index = Math.floor(images_length / 2)
        item.images = item.images[replace_index] ? [item.images[replace_index], ...item.images] : [item.images[images_length - 1], ...item.images]
      }
    }
  }

  if (self.username === 'shopbosoup') {
    const up = 50

    // console.log('replace_get_product_by_page', response)
    if (response.data && response.data.data && response.data.data.list) {
      for (const item of response.data.data.list) {
        // item.name = item.name.replace(/shop bố soup/ig, '').trim()
        // item.name = item.name.replace(/shop bo soup/ig, '').trim()
        // item.name = item.name.replace(/bố soup/ig, '').trim()
        // item.name = item.name.replace(/bo soup/ig, '').trim()
        item.name = 'Sản phẩm ' + random_range(1000, 9999)

        const images_length = item.images.length
        const replace_index = Math.floor(images_length / 2)
        item.images = item.images[replace_index] ? [item.images[replace_index], ...item.images] : [item.images[images_length - 1], ...item.images]
      }
    }
  }
}

export function replace_get_top_hour(self, response) {
  if (!response || !self.is_buff) return

  if (self.username === 'umiha') {
    const up = 80

    // console.log('replace_get_top_hour', response)
    if (response.body && response.body.data) {
      for (const item of response.body.data) {
        item.buyers += Math.floor(item.buyers * up / 100)
        item.orders += Math.floor(item.orders * up / 100)
        item.gmv += Math.floor(item.gmv * up / 100)
      }
    }
  }

  if (self.username === 'shopbosoup') {
    const up = 50

    // console.log('replace_get_top_hour', response)
    if (response.body && response.body.data) {
      for (const item of response.body.data) {
        item.buyers += Math.floor(item.buyers * up / 100)
        item.orders += Math.floor(item.orders * up / 100)
        item.gmv += Math.floor(item.gmv * up / 100)
      }
    }
  }
}

export function replace_get_top_state(self, response) {
  if (!response || !self.is_buff) return

  if (self.username === 'umiha') {
    const up = 80

    // console.log('replace_get_top_state', response)
    if (response.body && response.body.data) {
      for (const key of Object.keys(response.body.data)) {
        for (const item of response.body.data[key]) {
          item.buyers += Math.floor(item.buyers * up / 100)
          item.exist_buyers += Math.floor(item.exist_buyers * up / 100)
          item.orders += Math.floor(item.orders * up / 100)
          item.gmv += Math.floor(item.gmv * up / 100)
        }
      }
    }
  }

  if (self.username === 'shopbosoup') {
    const up = 50

    // console.log('replace_get_top_state', response)
    if (response.body && response.body.data) {
      for (const key of Object.keys(response.body.data)) {
        for (const item of response.body.data[key]) {
          item.buyers += Math.floor(item.buyers * up / 100)
          item.exist_buyers += Math.floor(item.exist_buyers * up / 100)
          item.orders += Math.floor(item.orders * up / 100)
          item.gmv += Math.floor(item.gmv * up / 100)
        }
      }
    }
  }
}

export function replace_buy_together(self, response) {
  if (!response || !self.is_buff) return

  if (self.username === 'umiha') {
    const up = 80

    // console.log('replace_buy_together', response)
    if (response.body && response.body.data) {
      for (const item of response.body.data) {
        item.buyers += Math.floor(item.buyers * up / 100)
        item.gmv += Math.floor(item.gmv * up / 100)
        item.count += Math.floor(item.count * up / 100)
        item.quantity += Math.floor(item.quantity * up / 100)

        for (const model of item.model_list) {
          model.buyers += Math.floor(model.buyers * up / 100)
          model.gmv += Math.floor(model.gmv * up / 100)
          model.count += Math.floor(model.count * up / 100)
          model.quantity += Math.floor(model.quantity * up / 100)
        }
      }
    }
  }

  if (self.username === 'shopbosoup') {
    const up = 50

    // console.log('replace_buy_together', response)
    if (response.body && response.body.data) {
      for (const item of response.body.data) {
        item.buyers += Math.floor(item.buyers * up / 100)
        item.gmv += Math.floor(item.gmv * up / 100)
        item.count += Math.floor(item.count * up / 100)
        item.quantity += Math.floor(item.quantity * up / 100)

        for (const model of item.model_list) {
          model.buyers += Math.floor(model.buyers * up / 100)
          model.gmv += Math.floor(model.gmv * up / 100)
          model.count += Math.floor(model.count * up / 100)
          model.quantity += Math.floor(model.quantity * up / 100)
        }
      }
    }
  }
}

export function replace_get_product_performance_main(self, response) {
  if (!response || !self.is_buff) return

  if (self.username === 'umiha') {
    const up = 80

    // console.log('replace_get_product_performance_main', response)
    if (response.data && response.data.result && response.data.result.items) {
      for (const item of response.data.result.items) {
        // item.name = item.name.replace(/umiha/ig, '').trim()
        // item.name = item.name.replace(/umihome/ig, '').trim()
        item.name = 'Sản phẩm ' + random_range(1000, 9999)

        for (const key of Object.keys(item)) {
          if (!key.includes('_') || key.includes('rate') || Number.isNaN(item[key])) continue

          item[key] += Math.floor(item[key] * up / 100)
        }
      }
    }
  }

  if (self.username === 'shopbosoup') {
    const up = 50

    // console.log('replace_get_product_performance_main', response)
    if (response.data && response.data.result && response.data.result.items) {
      for (const item of response.data.result.items) {
        // item.name = item.name.replace(/shop bố soup/ig, '').trim()
        // item.name = item.name.replace(/shop bo soup/ig, '').trim()
        // item.name = item.name.replace(/bố soup/ig, '').trim()
        // item.name = item.name.replace(/bo soup/ig, '').trim()
        item.name = 'Sản phẩm ' + random_range(1000, 9999)

        for (const key of Object.keys(item)) {
          if (!key.includes('_') || key.includes('rate') || Number.isNaN(item[key])) continue

          item[key] += Math.floor(item[key] * up / 100)
        }
      }
    }
  }
}

export function replace_dashboard__key_metrics(self, response) {
  if (!response || !self.is_buff) return

  if (self.username === 'umiha') {
    const up = 80

    // console.log('replace_dashboard__key_metrics', response)
    if (response.data && response.data.result) {
      for (const key of Object.keys(response.data.result)) {
        if (!key.includes('_') || key.includes('rate') || Number.isNaN(response.data.result[key].value)) continue

        response.data.result[key].value += Math.floor(response.data.result[key].value * up / 100)
        for (const point of response.data.result[key].points) {
          point.value += Math.floor(point.value * up / 100)
        }
      }
    }
  }

  if (self.username === 'shopbosoup') {
    const up = 50

    // console.log('replace_dashboard__key_metrics', response)
    if (response.data && response.data.result) {
      for (const key of Object.keys(response.data.result)) {
        if (!key.includes('_') || key.includes('rate') || Number.isNaN(response.data.result[key].value)) continue

        response.data.result[key].value += Math.floor(response.data.result[key].value * up / 100)
        for (const point of response.data.result[key].points) {
          point.value += Math.floor(point.value * up / 100)
        }
      }
    }
  }
}

export function replace_marketing_get_search_ads(self, response) {
  if (!response || !self.is_buff) return

  if (self.username === 'umiha') {
    const up = 80

    // console.log('replace_marketing_get_search_ads', response)
    if (response.data && response.data.data && response.data.data.campaign_ads_list) {
      for (const item of response.data.data.campaign_ads_list) {
        if (item.product && item.product.name) {
          // item.product.name = item.product.name.replace(/umiha/ig, '').trim()
          // item.product.name = item.product.name.replace(/umihome/ig, '').trim()
          item.product.name = 'Quảng cáo sản phẩm ' + random_range(1000, 9999)
        }
        if (item.campaign.type === 'shop') {
          item.campaign.name = 'Quảng cáo shop ' + random_range(1000, 9999)
          item.advertisements[0].extinfo.shop_customisation.display_title = 'Quảng cáo shop ' + random_range(1000, 9999)
          item.advertisements[0].extinfo.shop_customisation.image_url = '39f4b27c9931ae34e8281a3f4978abba'
        }

        item.report.impression.value += Math.floor(item.report.impression.value * up / 100)
        item.report.click.value += Math.floor(item.report.click.value * up / 100)
        item.report.broad_order.value += Math.floor(item.report.broad_order.value * up / 100)
        item.report.broad_gmv.value += Math.floor(item.report.broad_gmv.value * up / 100)
        item.report.direct_gmv.value += Math.floor(item.report.direct_gmv.value * up / 100)
      }
    }
  }

  if (self.username === 'shopbosoup') {
    const up = 80

    // console.log('replace_marketing_get_search_ads', response)
    if (response.data && response.data.data && response.data.data.campaign_ads_list) {
      for (const item of response.data.data.campaign_ads_list) {
        if (item.product && item.product.name) {
          // item.product.name = item.product.name.replace(/shop bố soup/ig, '').trim()
          // item.product.name = item.product.name.replace(/shop bo soup/ig, '').trim()
          // item.product.name = item.product.name.replace(/bố soup/ig, '').trim()
          // item.product.name = item.product.name.replace(/bo soup/ig, '').trim()
          item.product.name = 'Quảng cáo sản phẩm ' + random_range(1000, 9999)
        }
        if (item.campaign.type === 'shop') {
          item.campaign.name = 'Quảng cáo shop ' + random_range(1000, 9999)
          item.advertisements[0].extinfo.shop_customisation.display_title = 'Quảng cáo shop ' + random_range(1000, 9999)
          item.advertisements[0].extinfo.shop_customisation.image_url = '39f4b27c9931ae34e8281a3f4978abba'
        }

        item.report.impression.value += Math.floor(item.report.impression.value * up / 100)
        item.report.click.value += Math.floor(item.report.click.value * up / 100)
        item.report.broad_order.value += Math.floor(item.report.broad_order.value * up / 100)
        item.report.broad_gmv.value += Math.floor(item.report.broad_gmv.value * up / 100)
        item.report.direct_gmv.value += Math.floor(item.report.direct_gmv.value * up / 100)
      }
    }
  }
}

export function replace_shop_username(self) {
  if (!self.is_buff) return

  if (self.username === 'patek.official') {
    self.username = 'umiha'
  }
  if (self.username === 'philippe_official') {
    self.username = 'shopbosoup'
  }
}

export function replace_get_shop_info(self, response) {
  if (!response || !self.is_buff) return

  if (self.username === 'umiha') {
    const up = 80

    // console.log('replace_get_shop_info', response)
    if (response.data) {
      response.data.portrait = '39f4b27c9931ae34e8281a3f4978abba'
    }
  }

  if (self.username === 'shopbosoup') {
    const up = 50

    // console.log('replace_get_shop_info', response)
    if (response.data) {
      response.data.portrait = '39f4b27c9931ae34e8281a3f4978abba'
    }
  }
}

export function replace_marketing_get_campaign_detail(self, response) {
  if (!response || !self.is_buff) return

  // if (self.username === 'umiha') {
  //   const up = 80
  //
  //   console.log('replace_marketing_get_campaign_detail', response)
  // }

  // console.log('replace_marketing_get_campaign_detail', response.data.data)

  // if (response.data && response.data.data && response.data.data.campaign_ads_list && response.data.data.campaign_ads_list.length) {
  //   const [campaign] = response.data.data.campaign_ads_list
  if (response.data && response.data.data) {
    const campaign = response.data.data

    if (campaign.campaign.name) {
      if (self.username === 'umiha') {
        // campaign.campaign.name = campaign.campaign.name.replace(/umiha/ig, '').trim()
        // campaign.campaign.name = campaign.campaign.name.replace(/umihome/ig, '').trim()
        campaign.campaign.name = 'Quảng cáo sản phẩm ' + random_range(1000, 9999)
      }
      if (self.username === 'shopbosoup') {
        // campaign.campaign.name = campaign.campaign.name.replace(/shop bố soup/ig, '').trim()
        // campaign.campaign.name = campaign.campaign.name.replace(/shop bo soup/ig, '').trim()
        // campaign.campaign.name = campaign.campaign.name.replace(/bố soup/ig, '').trim()
        // campaign.campaign.name = campaign.campaign.name.replace(/bo soup/ig, '').trim()
        campaign.campaign.name = 'Quảng cáo sản phẩm ' + random_range(1000, 9999)
      }
    }

    for (const advertisement of campaign.advertisements) {
      // console.log(advertisement)
      if (advertisement.extinfo.shop_customisation.image_url) {
        advertisement.extinfo.shop_customisation.image_url = '39f4b27c9931ae34e8281a3f4978abba'
      }

      if (advertisement.extinfo.shop_customisation.display_title) {
        if (self.username === 'umiha') {
          advertisement.extinfo.shop_customisation.display_title = advertisement.extinfo.shop_customisation.display_title.replace(/umiha/ig, 'patek').trim()
          advertisement.extinfo.shop_customisation.display_title = advertisement.extinfo.shop_customisation.display_title.replace(/umihome/ig, 'patek').trim()
        }
        if (self.username === 'shopbosoup') {
          advertisement.extinfo.shop_customisation.display_title = advertisement.extinfo.shop_customisation.display_title.replace(/shop bố soup/ig, 'philippe').trim()
          advertisement.extinfo.shop_customisation.display_title = advertisement.extinfo.shop_customisation.display_title.replace(/shop bo soup/ig, 'philippe').trim()
          advertisement.extinfo.shop_customisation.display_title = advertisement.extinfo.shop_customisation.display_title.replace(/bố soup/ig, 'philippe').trim()
          advertisement.extinfo.shop_customisation.display_title = advertisement.extinfo.shop_customisation.display_title.replace(/bo soup/ig, 'philippe').trim()
        }
      }

      if (advertisement.extinfo.keywords) {
        for (let i = 0; i < advertisement.extinfo.keywords.length; i++) {
          advertisement.extinfo.keywords[i].keyword = `Từ khóa ${i + 1}`
        }
      }
    }
  }
}

export function replace_get_product_by_graphql(self, response) {
  if (!response || !self.is_buff) return

  // console.log('replace_get_product_by_graphql', response.data)
  if (response.data && response.data.data && response.data.data.products && response.data.data.products.items) {
    for (const item of response.data.data.products.items) {
      item.name = 'Sản phẩm ' + random_range(1000, 9999)

      const images_length = item.images.split(',').length
      const replace_index = Math.floor(images_length / 2)
      item.images = item.images.split(',')[replace_index] ? item.images.split(',')[replace_index] + ',' + item.images : item.images.split(',')[images_length - 1] + ',' + item.images

      for (const model of item.modelList) {
        model.name = 'Phân loại ' + random_range(1000, 9999)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/addon/_replace.js